module.exports = __webpack_public_path__ + "static/img/map-marker.6ec7e569.svg";